define('modules/layout/guide-modules',['require','jquery','underscore','react','components/elements/link'],function(require) {
  var $, GuideModules, Link, React, div, li, p, ul, _, _ref;
  $ = require("jquery");
  _ = require("underscore");
  React = require("react");
  _ref = React.DOM, div = _ref.div, p = _ref.p, ul = _ref.ul, li = _ref.li;
  Link = require("components/elements/link");
  return GuideModules = {
    getModules: function() {
      var defaultRole, modules;
      defaultRole = _.find(EverTrue.Organization.get("roles"), function(role) {
        return role["default"] === true;
      });
      defaultRole = defaultRole || "Alumni";
      return modules = [
        {
          img_src: "hi_avatar.png",
          id: "tasks",
          header: "Getting Started",
          media_body: p(null, "The task list below will help you launch with EverTrue. Try to reach 100%, and don't miss the Feedback and the Support widget on the right.")
        }, {
          id: "notifications",
          img_src: "notifications.png",
          header: "Notification Emails",
          body: p(null, "EverTrue sends ", Link({
            href: "http://help.evertrue.com/13178-Community-Onboarding/console-notifications",
            open_new_tab: true
          }, "automatic notifications "), "via email. You can enter multiple email addresses by separating each one with a comma.")
        }, {
          id: "social",
          img_src: "social_media.png",
          header: "Social Media Content",
          body: p(null, "Display content from up to five social networks within the app. Choose from Facebook, Twitter, Youtube, Vimeo, Smugmug, and Flickr.")
        }, {
          id: "custom",
          img_src: "external_links.png",
          header: "Link to Online Content",
          body: p(null, "Enter up to four URLs and give them descriptive titles. These will appear in the navigation panel of your app, and will open the user's web browser outside of the application.")
        }, {
          id: "importer",
          img_src: "manage_records.png",
          header: "Import Data",
          body: div(null, p(null, "Import CSV files to add, edit, or update records with new types of data."), p(null, "Be sure to visit our ", Link({
            href: "https://evertrue.forumbee.com/t/q6hwkl4/data-format-guides",
            open_new_tab: true
          }, "Knowledge Base "), "to learn more about best practices."))
        }, {
          id: "search",
          img_src: "manage_records.png",
          header: "Search Records",
          body: div(null, p(null, "Search constituents and add or edit records."), p(null, "Be sure to visit our Knowledge Base for articles on ", Link({
            href: "https://evertrue.forumbee.com/",
            open_new_tab: true
          }, "EverTrue administration")))
        }, {
          id: "resources",
          img_src: "notifications.png",
          header: "Resources",
          media_body: div(null, p(null, "Use these tools to help prepare your messaging and spread the word in different channels. Don't forget:"), ul(null, li(null, "Your ", Link({
            href: "/dashboard/reporting"
          }, "reports")), li(null, "Knowledgebase ", Link({
            href: "http://help.evertrue.com/13177-Marketing/marketing-strategy-resources",
            open_new_tab: true
          }, "marketing resources")), li(null, Link({
            href: "http://www.evertrue.com/onboarding/assets/EverTrue_Media_Packet_v1.0.zip"
          }, "EverTrue branding asset"))))
        }, {
          id: "facebook_ads",
          img_src: "notifications.png",
          header: "Facebook Ads",
          media_body: div(null, p(null, "Use Facebook Ads to reach your constituents and get more EverTrue users!"), p(null, Link({
            href: "http://help.evertrue.com/13177-Marketing/facebook-mobile-ads ",
            open_new_tab: true
          }, "Use this guide to create your ad quickly and easily.")))
        }, {
          id: "requests",
          img_src: "login_request_icon.png",
          header: "New User Requests",
          media_body: p(null, "Some constituents asking to join your community don't have an email matching your records. Review their requests, and ask for more information if needed.")
        }, {
          id: "roles",
          img_src: "roles.png",
          header: "Roles & Visibilty",
          media_body: div(null, p(null, "A role is a group of constituents with permission to view certain information of constituents belonging to other roles. Roles help manage data visibility in the Community app."), p(null, "Admin is the default role for your staff, and " + defaultRole.name + " is the default role for your constituents."))
        }, {
          id: "flex",
          img_src: "account_setup.png",
          header: "Custom Fields",
          media_body: p(null, "Enable & disable custom fields for each app. Edit field labels, which are displayed to users of Community, EverTrue & Console")
        }, {
          id: "contacts",
          img_src: "account_setup.png",
          header: "Contacts"
        }, {
          id: "users",
          img_src: "account_setup.png",
          header: "Users"
        }, {
          id: "manage-users",
          img_src: "account_setup.png",
          header: "Staff Users",
          media_body: p(null, "Set up staff users.")
        }
      ];
    }
  };
});

//# sourceMappingURL=guide-modules.js.map
;
